// Builds a pre-filled purchase-request mailto so the "Buy" buttons reach a real
// sales channel. Interim until a card checkout (Stripe / Lemon Squeezy) is wired —
// swap the href for the hosted checkout URL when that exists.
export function orderMailto(opts: { product: string; tier: string; price: string }): string {
  const subject = `Purchase: ${opts.product} — ${opts.tier} (${opts.price})`;
  const body = [
    'Hi vibelibs team,',
    '',
    `I'd like to buy ${opts.product} — ${opts.tier} (${opts.price}).`,
    '',
    'Name:',
    'Company:',
    'Seats / developers:',
    'Billing email:',
    '',
    'Please send a payment link or invoice. Thanks!',
  ].join('\n');
  return `mailto:hello@vibelibs.dev?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
